import React, { useState, useRef, useEffect } from "react";
import clsx from "clsx";
import Button from "./Button";

const SelectBox = ( props ) => {

  const [ isShowList, setIsShowList ] = useState( false );

  const label = useRef();

  useEffect( () => {
    document.addEventListener( 'click', hideList );
    return () => {
      document.removeEventListener( 'click', hideList );
    };
  }, [] );

  const hideList = ( event ) => {
    label.current !== event.target && setIsShowList( false );
  };

  const showList = () => {
    setIsShowList( ! isShowList );
  };

  const mapList = ( value, index ) => {
    return (
      <li key={ index }>
        <Button className={ props.value.data === value.data ? 'selected' : null } data-data={ value.data } onClick={ changeList }>{ value.label }</Button>
      </li>
    );
  };

  const changeList = ( event ) => {
    props.onChange( props.data.filter( v => event.target.dataset.data === v.data )[ 0 ] );
  };

  const LIST = props.data?.map( mapList );

  return (
    <div className={ clsx( props.className, isShowList && 'opened' ) || null } style={ props.style }>
      <div className="selected_txt" ref={ label } onClick={ showList }>{ props.value.label }</div>
      { isShowList && <div className="select_option"><ul>{ LIST }</ul></div> }
    </div>
  );

};

SelectBox.defaultProps = {
  data : [],
  value : {},
  onChange : () => {}
};

export default SelectBox;
